import { render } from "./SideCollage.vue?vue&type=template&id=9b3ebe08&scoped=true"
const script = {}

import "./SideCollage.vue?vue&type=style&index=0&id=9b3ebe08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3ebe08"]])

export default __exports__